module.exports = __webpack_public_path__ + "static/media/features-banner.52c4986c.png";